<template>
  <div class="page page-Works" :class="{ loaded: isLoaded}">

    <template v-for="(work, index) in works">
      <transition :enter-active-class="$store.state.enterClassName" :leave-active-class="$store.state.leaveClassName">
        <div class="video video--black" v-if="index == currentWorkIndex && view == 'list'" :style="bgImgStyle(work.preview)" :class="{fullscreen: videoFullscreen}">
          <vimeo-player class="player" :ref="'player' + currentWorkIndex" :class="{hidden:videoPlayerReady != true}" :video-id="work.videoId" :autoplay="true" :options="videoOptions" @ready="onVideoPlayerReady"></vimeo-player>
<!--          <vimeo-player v-if="videoFullscreen == true" class="player" :ref="'playerFull' + currentWorkIndex" :video-id="work.videoFullId" :autoplay="true" :options="videoFullOptions"></vimeo-player>-->
          <div class="video__voile" :class="{hidden: videoFullscreen}"></div>
        </div>
      </transition>

      <div class="work-creators" v-if="index == currentWorkIndex && work.creators" :class="{hidden: !videoFullscreen || videoRealFullscreen}">
        <VuePerfectScrollbar class="scroll-area scroll-area--vertical scroll-area--white" :settings="scrollSettings">
          <div v-for="creator in work.creators" class="work-creator">
            <div class="work-creator__name" v-html="creator.name"></div>
<!--            <div class="work-creator__lastname" v-html="creator.lastname"></div>-->
            <div class="work-creator__prof" v-html="creator.prof"></div>
          </div>
        </VuePerfectScrollbar>

        <div class="work-creators__btns" v-if="isMobile">
          <span class="btn btn--square btn--big" @click="hideFullscreenVideo()"><span>{{ _('btnClose') }}</span></span>
        </div>
      </div>
    </template>

    <div class="content">

      <div class="logo" v-if="isMobile" :class="{hidden: videoFullscreen}"></div>

      <template v-for="work in works" v-if="!isMobile">
        <transition :enter-active-class="$store.state.enterClassNameWork" :leave-active-class="$store.state.leaveClassNameWork">
          <div class="work-title glitch" v-if="work.active && view == 'list'" :class="{hidden: videoFullscreen}"><span class="glitch-action" :data-text="work.title" v-html="work.title"></span></div>
        </transition>
      </template>

      <transition :enter-active-class="$store.state.enterClassNameWork" :leave-active-class="$store.state.leaveClassNameWork">
        <div v-if="view == 'list' || isMobile">
          <!--            ЛИСТИНГ            -->
          <div class="works" :class="{hidden: videoFullscreen}" v-if="!isMobile">

            <template v-for="work in works">
              <div class="work" :class="{active: work.active, next: work.next, prev: work.prev}" :style="{'z-index': work.zIndex}">
                <div class="work__preview" :style="bgImgStyle(work.preview)" @click="clickNextWork(work)">
                  <vimeo-player class="player" v-if="work.active" :video-id="work.videoId" :autoplay="true" :options="videoOptions"></vimeo-player>
                </div>
              </div>
            </template>

          </div>

          <div class="works-border" :class="{fullscreen: videoFullscreen && !isMobile}">
            <template v-for="(work, index) in works">
              <div class="works-border__btns" v-if="index == currentWorkIndex" :class="{hidden: videoRealFullscreen || (isMobile && videoFullscreen)}">

                <span @click="showFullscreenVideo()" v-if="isMobile" class="work__download" v-html="_('btnCredentials')"></span>
                <a :href="work.video" data-fancybox class="work__play" v-if="isMobile" v-html="_('btnPlay')"></a>

                <a :href="work.presentation" v-if="!isMobile && work.presentation" target="_blank" class="work__download glitch" :class="{'work__download--big': videoFullscreen}">
                  <span class="glitch-action" :data-text="_('btnDownload')" v-html="_('btnDownload')"></span>
                </a>
                <span @click="showFullscreenVideo()" v-if="!isMobile" class="glitch work__play"  :class="{hidden: videoFullscreen}">
                  <span class="glitch-action" :data-text="_('btnPlay')" v-html="_('btnPlay')"></span>
                </span>
                <span @click="toggleRealFullscreenVideo()" class="work__fullscreen" v-if="!isMobile && videoFullscreen" :class="{hidden: !videoFullscreen}"></span>
              </div>
            </template>
          </div>

        </div>
      </transition>

      <transition :enter-active-class="$store.state.enterClassNameWork" :leave-active-class="$store.state.leaveClassNameWork">
        <div class="works works--grid" v-if="view == 'grid' && !isMobile">
          <!--            СЕТКА            -->
          <VuePerfectScrollbar class="scroll-area" :settings="scrollSettings">

            <a :href="work.video" data-fancybox class="work-grid-elem" v-for="work in works" :style="bgImgStyle(work.preview)" >
              <div class="work-grid-elem__name glitch"><span class="glitch-action" :data-text="work.title" v-html="work.title"></span></div>
            </a>
            <div class="work-grid-elem work-grid-elem--fake" v-for="index in fakeWorks" :class="{'work-grid-elem--light': index % 2 != 1 }"></div>

          </VuePerfectScrollbar>
        </div>
      </transition>

      <div class="work-btns" v-if="!isMobile" :class="{hidden: videoFullscreen}">
        <a :href="_('presentation')" target="_blank" class="btn btn--blue glitch"><span><span class="glitch-action" :data-text="_('btnDownloadFull')" v-html="_('btnDownloadFull')"></span></span></a>
        <div class="work-btns__note" v-html="_('note')"></div>
      </div>

      <div class="works-pagination" :class="{hidden: videoFullscreen || view != 'list'}">
        <div class="works-pagination__prev" @click="moveWork(-1)" :class="{disabled: currentWorkIndex == 0}"><span v-if="isMobile">{{ _('btnPrevious') }}</span></div>
        <div class="works-pagination__next" @click="moveWork(1)" :class="{disabled: currentWorkIndex == works.length - 1}"><span v-if="isMobile">{{ _('btnNext') }}</span></div>
      </div>
    </div>

    <div class="view" :class="{hidden: videoFullscreen}" v-if="!isMobile">
      <div class="view__btn view__btn--list" :class="{active: view == 'list'}" @click="view = 'list'"></div>
      <div class="view__btn view__btn--grid" :class="{active: view == 'grid'}" @click="view = 'grid'"></div>
    </div>

    <div class="work-close" v-if="!isMobile" :class="{hidden: !videoFullscreen}" @click="hideFullscreenVideo()"></div>

  </div>
</template>

<script>
  import {loader} from '../mixins/loader';
  import {isMobile} from '../mixins/isMobile';
  import {functions} from '../mixins/functions';

  export default {
    name: 'Works',
    mixins: [loader, isMobile, functions],

    data() {
      return {
        pageData: {page: 'Works'},
        works: [],
        currentWorkIndex: 0,
        videoPlayerReady: false,
        videoOptions: {
            background: 1,
            loop: true
        },
        videoFullOptions: {
            controls: true,
            loop: true,
            muted: false
        },
        videoFullscreen: false,
        videoRealFullscreen: false,
        view: 'list',
        scrollSettings: {
            suppressScrollX: true,
        },
      }
    },

    deactivated() {
      this.isLoaded = false;
    },

    //activated() {
    mounted() {
      var _t = this;
      _t.videoFullscreen = false;
      _t.videoRealFullscreen = false;
      _t.view = 'list';

      if (_t.$store.state.pagesLoaded.App && _t.$store.state.pagesLoaded.Works) {
        _t.onActivated();
      } else {
        //_t.$store.commit('loaderON');

        _t.$store.subscribe((mutation, state) => {
          if (mutation.type === 'pageLoaded' && mutation.payload.page == 'Works') {
            _t.onActivated();
          }
        });
      }
    },

    created(){
      this.$store.dispatch('loadData', {
        page: 'Works'
      });
    },

    watch: {
        imagesLoaded(val) {
            let _t = this;

            if (val && _t.videoPlayerReady) {
                _t.pageLoaded();
            }
        },
        videoPlayerReady(val) {
            let _t = this;

            if (val && _t.imagesLoaded) {
                _t.pageLoaded();
            }
        },
    },

    computed: {
        fakeWorks: function () {
            let _t = this;

            if (_t.works.length <= 12) {
                return 12 - _t.works.length;
            } else {
                return _t.works.length % 3 ? 3 - _t.works.length % 3 : 0;
            }
        }
    },

    methods: {
      onActivated() {
        var _t = this;
        _t.works = _t._('works');

        let first = true;
        let second = true;
        for (let i in _t.works) {
            _t.$set(_t.works[i], 'active', false);
            _t.$set(_t.works[i], 'next', false);
            _t.$set(_t.works[i], 'prev', false);
            _t.$set(_t.works[i], 'zIndex', i*1+1);

            if (second && !first) {
                _t.$set(_t.works[i], 'next', true);
                second = false;
            }
            if (first) {
                _t.$set(_t.works[i], 'active', true);
                first = false;
            }
        }

        if (_t.imagesLoaded) {
          //_t.pageLoaded();
        } else {
          var images = [];

          for (let i in _t.works) {
              for (let j in _t.works[i].preview) {
                  images.push(_t.works[i].preview[j]);
              }
          }

          _t.loadImages(images, true);
        }
      },
      clickNextWork(work, index) {
          if (work.active) {
              return;
          }

          let _t = this;

          _t.moveWork(work.next ? 1 : -1);
      },
      moveWork(delta) {
          let _t = this;

          if (delta < 0 && !_t.works[_t.currentWorkIndex - 1]) {
              return;
          }
          if (delta > 0 && !_t.works[_t.currentWorkIndex + 1]) {
              return;
          }

          _t.videoPlayerReady = false;
          _t.currentWorkIndex += delta;
          let index = _t.currentWorkIndex;

          //prev
          if (_t.works[index - 1]) {
              _t.works[index - 1].prev = true;
              _t.works[index - 1].next = false;
              _t.works[index - 1].active = false;
          }

          //current
          _t.works[index].active = true;
          _t.works[index].next = false;
          _t.works[index].prev = false;

          //next
          if (_t.works[index + 1]) {
              _t.works[index + 1].next = true;
              _t.works[index + 1].prev = false;
              _t.works[index + 1].active = false;
          }

          if (delta < 0 && _t.works[index + 2]) {
              _t.works[index + 2].next = false;
              _t.works[index + 2].prev = false;
              _t.works[index + 2].active = false;
          }
      },
      onVideoPlayerReady() {
          let _t = this;

          _t.videoPlayerReady = true;
      },
      showFullscreenVideo() {
          let _t = this;

          if (!_t.isMobile) {
              _t.$store.commit('hideMenu');
          }
          _t.$store.commit('hideMobileMenuBtn');
          _t.videoFullscreen = true;
          _t.videoRealFullscreen = false;

          _t.$refs['player' + _t.currentWorkIndex][0].update(_t.works[_t.currentWorkIndex].videoFullId);
          setTimeout(function () {
              _t.$refs['player' + _t.currentWorkIndex][0].unmute();
          }, 500);
      },
      hideFullscreenVideo() {
          let _t = this;

          if (!_t.isMobile) {
              _t.$store.commit('showMenu');
          }
          _t.$store.commit('showMobileMenuBtn');
          _t.videoFullscreen = false;
          _t.videoRealFullscreen = false;

          _t.$refs['player' + _t.currentWorkIndex][0].update(_t.works[_t.currentWorkIndex].videoId);
          _t.$refs['player' + _t.currentWorkIndex][0].mute();
      },
      toggleRealFullscreenVideo() {
          let _t = this;

          _t.videoRealFullscreen = !_t.videoRealFullscreen;
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Works.vue